"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.luhnCheck = luhnCheck;
function luhnCheck(num) {
    const arr = num
        .split("")
        .reverse()
        .map((x) => Number.parseInt(x));
    const lastDigit = arr.shift();
    let sum = arr.reduce((acc, val, i) => i % 2 !== 0 ? acc + val : acc + ((val *= 2) > 9 ? val - 9 : val), 0);
    sum += lastDigit !== null && lastDigit !== void 0 ? lastDigit : 0;
    return sum % 10 === 0;
}
//# sourceMappingURL=luhnCheck.js.map